import { Link } from "react-router-dom";

/**
 * SmartStoryLink — the canonical "how do I open this story?" component.
 *
 * External `news_link` items open the publisher's URL directly in a new
 * tab (skipping the NaturePulse interim page — one less click for the
 * reader, and it makes attribution unmistakable). Everything else
 * (articles, personal_stories, observations, photo_stories, questions,
 * discussions, etc.) opens the internal `/stories/{id}` page.
 *
 * Usage:
 *   <SmartStoryLink story={s} className="…">{children}</SmartStoryLink>
 */
export default function SmartStoryLink({ story, className, children, ...rest }) {
  const isExternal = story?.story_type === "news_link" && (story.canonical_url || story.url);
  if (isExternal) {
    return (
      <a
        href={story.canonical_url || story.url}
        target="_blank"
        rel="noreferrer noopener"
        className={className}
        data-testid={rest["data-testid"] || `smart-link-external-${story.id}`}
        {...rest}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      to={`/stories/${story?.id || ""}`}
      className={className}
      {...rest}
    >
      {children}
    </Link>
  );
}
